var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteIconLightGray = function SvgDeleteIconLightGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.284 7.5-.289 7.5m-3.99 0-.289-7.5m8.307-2.675q.427.066.852.139m-.852-.139-.89 11.569a1.875 1.875 0 0 1-1.87 1.731H6.737c-.98 0-1.794-.754-1.87-1.731L3.978 4.825m12.046 0a40 40 0 0 0-2.898-.33m-10 .469q.425-.074.852-.139m0 0a40 40 0 0 1 2.898-.33m6.25 0v-.763c0-.983-.759-1.803-1.741-1.835a43 43 0 0 0-2.768 0c-.982.032-1.741.852-1.741 1.835v.763m6.25 0a40.6 40.6 0 0 0-6.25 0"
  })));
};
export { SvgDeleteIconLightGray as ReactComponent };
export default __webpack_public_path__ + "9b604ea54800084f69732344fc629bce.svg";